export { default } from './FormRateCar';
